export default __webpack_public_path__ + "static/CuervoVP-greenScreen2c-fa2337e17d733628c4b3835aef493141.jpg";